const CACHE_EXPIRY = 24 * 60 * 60 * 1000;

export function getCachedImage(key) {
  const cached = localStorage.getItem(key);
  if (!cached) return null;
  try {
    const { dataUrl, timestamp } = JSON.parse(cached);
    if (Date.now() - timestamp < CACHE_EXPIRY) {
      return dataUrl;
    } else {
      localStorage.removeItem(key);
      return null;
    }
  } catch (error) {
    localStorage.removeItem(key);
    return null;
  }
}

export function setCachedImage(key, dataUrl) {
  const cacheEntry = {
    dataUrl,
    timestamp: Date.now(),
  };
  localStorage.setItem(key, JSON.stringify(cacheEntry));
}

export async function getCachedImageOrFetch(url) {
  if (!url) return url;
  const cached = getCachedImage(url);
  if (cached) {
    return cached;
  }
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);
    setCachedImage(url, blobUrl);
    return blobUrl;
  } catch (error) {
    console.error('Error fetching image:', error);
    return url;
  }
}
